// extracted by mini-css-extract-plugin
export default {"generalInsights":"general-insights_generalInsights__GzQ95","title":"general-insights_title__M6Nn4","comingSoon":"general-insights_comingSoon__S1osY"};